import { toFallbackMaxAgeItems } from "../../../../actions/Checks/checkSelection";
import FilterableConfigList from "./FilterableConfigList";

const defaultField = {
    field: {
        max_age_days: null,
    }
};

const getFieldForm = () => [
    {
        label: "Max age (days)",
        name: "max_age_days",
        type: "number",
        description: "Fallback checks older than this many days are not used.",
    },
];

const getFieldTitle = (object) => <b>{object?.max_age_days ?? "—"} days</b>;

// * fallback_check_max_age_days: a max age per display filter (fruit type, layer type, meta conditions); the first match applies
// * Older configs hold a single number or [{ fruit_type, max_age_days }]; they are shown, and saved, in the new shape
export default function FallbackMaxAgeConfigForm({ value, setValue, title = "Fallback check max age", name = "fallback_check_max_age_days" }) {
    const toItems = () => {
        if (Array.isArray(value)) return toFallbackMaxAgeItems(value);
        return value != null && value !== "" ? [{ field: { max_age_days: Number(value) } }] : [];
    };
    const items = toItems();

    return (
        <FilterableConfigList
            useDisplayFilter={["fruit_types", "exclude_fruit_types", "layer_types", "meta_conditions"]}
            name={name}
            title={title}
            description="Maximum age (in days) of fallback checks, per pallet: the first item whose display filter matches the pallet applies, e.g. 3 for avocado and 2 for mango. No match: no limit."
            fields={items}
            setArray={setValue}
            defaultField={defaultField}
            getFieldForm={getFieldForm}
            getFieldTitle={getFieldTitle}
        />
    );
}
